module.exports = __webpack_public_path__ + "static/media/react-redux.a8b012a0.jpg";